import React from 'react';

/**
 * Clean Zara-style top sub-navigation tab bar for switching dashboard views
 * Props:
 *   activeTab: 'overview' | 'sales' | 'products' | 'expenses' | 'website'
 *   onSelectTab: (tabId) => void
 */
const TABS = [
    { id: 'overview', label: 'Overview', path: '/dashboard' },
    { id: 'sales', label: 'Sales Analytics', path: '/dashboard/sales-analytics' },
    { id: 'products', label: 'Product Analytics', path: '/dashboard/product-analytics' },
    { id: 'expenses', label: 'Expense Management', path: '/dashboard/expense-management' },
    { id: 'website', label: 'Website Analytics', path: '/dashboard/website-analytics' },
];

const DashboardNav = ({ activeTab, onSelectTab }) => {
    return (
        <div className="w-full bg-white rounded-2xl border border-stone-200/80 p-1.5 shadow-xs mb-6 overflow-x-auto no-scrollbar">
            <nav className="flex items-center gap-1 min-w-max">
                {TABS.map((tab) => {
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => onSelectTab(tab.id, tab.path)}
                            className={`px-4 py-2.5 rounded-xl text-xs font-semibold tracking-wide transition-all duration-200 ${
                                isActive
                                    ? 'bg-stone-900 text-white shadow-xs'
                                    : 'text-stone-500 hover:text-stone-900 hover:bg-stone-100/60'
                            }`}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};

export default DashboardNav;
